import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';

import { LocalOffersDataSource } from '../../services/local-offers-data-source';
import { LocalOffersApiService } from '../../services/local-offers-api-service';
import { AddFiles } from 'src/modules/directives/components/add-files/component';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';
import { IOrganisationImage } from 'src/app/interfaces/organisation-image';
import { CarouselImagesAdd } from 'src/modules/carousel-image/components/add/component';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'offer-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class LocalOffersEdit implements OnInit {
  public form: FormGroup;
  public loading: boolean;
  private dataSource: LocalOffersDataSource;
  public localOfferId;
  public locationId;
  public image;
  public listingId;

  constructor(
    private dialog: MatDialog,
    protected dialogRef: MatDialogRef<LocalOffersEdit>,
    protected service: LocalOffersApiService,
    @Inject(MAT_DIALOG_DATA) public DataSource: CarouselImageDataSource,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private fb: FormBuilder
  ) {
    this.listingId = data.listingId;
  }

  ngOnInit() {
    this.dataSource = this.data.dataSource;
    const companyName = this.data.LocalOffer?.company_name
      ? this.data.LocalOffer.company_name
      : null;
    this.localOfferId = this.data.LocalOffer
      ? this.data.LocalOffer.offer_id
      : null;
    this.image = this.data?.LocalOffer?.image?.id && this.data.LocalOffer.image;
    this.form = this.fb.group({
      offer: [null, [Validators.required]],
      company_name: [companyName, [Validators.required]],
      expiry_date: [null, null],
      redemption_instructions: [null, null],
      t_cs: [null, null],
      description: [null, [Validators.required]],
      locations: this.fb.array([]),
    });

    if (this.data.LocalOffer?.locations) {
      this.data.LocalOffer.locations.map(() => this.addLocationFields());
    } else {
      this.addLocationFields();
    }

    if (this.data.LocalOffer) {
      Object.keys(this.data.LocalOffer).forEach((name) => {
        if (this.form.controls[name]) {
          this.form.controls[name].patchValue(this.data.LocalOffer[name]);
        }
      });
    }
  }

  addLocationFields() {
    this.locations().push(
      this.fb.group({
        location_id: [null, null],
        location_title: [null, [Validators.required]],
        lat: [null, [Validators.required]],
        lng: [null, [Validators.required]],
      })
    );
  }

  locations(): FormArray {
    return this.form.get('locations') as FormArray;
  }

  remove(index, row) {
    const { location_id } = row.getRawValue();
    this.dataSource
      .removeLocation(location_id)
      .then(() => this.locations().removeAt(index));
  }

  public addNewImage() {
    const config = new MatDialogConfig();
    if (this.listingId) {
      config.data = {
        role: 'listing-admin',
        organisationId: this.data.orgId,
        Carousel: [],
      };

      this.dialog
        .open(CarouselImagesAdd, config)
        .afterClosed()
        .subscribe((SelectedImages: IOrganisationImage) => {
          this.image = {
            src: SelectedImages[0]['file_name_encoded'],
            id: SelectedImages[0].id,
          };
        });
    } else {
      config.disableClose = true;
      config.data = { allowMultpleUpload: false, allowFiles: false };

      this.dialog
        .open(AddFiles, config)
        .afterClosed()
        .subscribe((files) => {
          this.image = files.files[0];
        });
    }
  }

  public clearImage() {
    this.image = null;
  }

  public getImageUrl(image) {
    return `${'this.imageUrl'}${'this.companyId'}/thumbnail/${encodeURI(
      image.file_name
    )}`;
  }

  onSubmit() {
    const localOffer = this.form.getRawValue();
    localOffer.offer_id = this.localOfferId;
    localOffer.listingId = this.listingId;
    localOffer.image = this.image;
    this.form.disable();
    this.dataSource.save(localOffer).then(
      (data) => {
        this.dialogRef.close({ ...localOffer, id: data.insertId });
      },
      (error) => this.form.enable()
    );
  }

  getImageSrc(image) {
    return this.image.src
      ? this.image.src
      : `${environment.cloudFrontDomainName}/0/${image.id}/thumbnail.${image.name.split('.').pop()}`;
  }
}
